<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="12">
        <div>
          <v-btn
            class="mr-2 mb-2"
            fab
            depressed
            dark
            x-small
            :to="{ name: 'ListclassMhs' }">
            <v-icon dark>
              mdi-arrow-left-thick
            </v-icon>
          </v-btn>
          <span class="title">Back to home</span>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-card outlined rounded="lg">
          <v-card-text>
            <v-row class="black--text" v-if="loading.getdata">
              <v-col cols="12" md="12" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
            </v-row>
            <v-row class="black--text" v-if="!loading.getdata && datalist.length > 0">
              <v-col cols="10" md="10">
                <div class="d-flex">
                  <div class="d-inline mr-5">
                    <v-img
                      :lazy-src="require('../../assets/default.jpg')"
                      max-height="70"
                      max-width="70"
                      :src="datalist[0].urlpic ? datalist[0].urlpic : ''">
                    </v-img>
                  </div>
                  <div class="d-inline">
                    <h2 class="text-md-h4 font-weight-bold">
                      {{ datalist[0].user_firstname }} {{ datalist[0].user_lastname }}
                    </h2>
                    <span class="text-subtitle-1">
                      NIM. {{ datalist[0].user_no ? datalist[0].user_no : '00'}}
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <v-tabs
                  v-model="tabdata"
                  show-arrows
                  @change="changeTab">
                  <v-tabs-slider :color="maincolor"></v-tabs-slider>
                  <v-tab href="#acc" active-class="main-style-slide">
                    Account
                  </v-tab>
                  <v-tab href="#pro-pic" active-class="main-style-slide">
                    Picture
                  </v-tab>
                </v-tabs>
                <v-divider></v-divider>
                <v-tabs-items :touchless="true" v-model="tabdata">
                  <v-tab-item value="acc">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold">
                              My Account
                              <v-icon
                                :color="maincolor"
                                class="mb-1 cursor-style"
                                @click="updateAccount(datalist[0])">
                                mdi-account-edit
                              </v-icon>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">First name</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ datalist[0].user_firstname ? datalist[0].user_firstname : '' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Last name</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ datalist[0].user_lastname ? datalist[0].user_lastname : '' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Email</span>
                            <h2 class="text-md-h6 font-weight-bold mb-3">
                              {{ useremail }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="pro-pic">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row justify="center" class="black--text">
                          <v-col cols="12" md="8">
                            <v-row class="text-center">
                              <v-col cols="12" md="5">
                                <div class="text-subtitle-1 mb-3">
                                  Current Picture
                                </div>
                                <v-img
                                  class="ma-auto"
                                  :lazy-src="require('../../assets/default.jpg')"
                                  max-height="150"
                                  max-width="150"
                                  aspect-ratio="1"
                                  :src="datalist[0].urlpic ? datalist[0].urlpic : ''">
                                </v-img>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-divider :vertical="!$vuetify.breakpoint.smAndDown"></v-divider>
                              </v-col>
                              <v-col cols="12" md="5">
                                <alertsp :alertdata="alertpic"></alertsp>
                                <div class="text-subtitle-1 mb-3">
                                  Update Picture
                                </div>
                                <div class="mb-3">
                                  <croppa v-model="myCroppa" :width="150" :height="150"></croppa>
                                </div>
                                <div>
                                  <v-btn
                                    :loading="loading.avatar"
                                    :disabled="loading.avatar"
                                    :color="maincolor"
                                    class="white--text"
                                    depressed
                                    small
                                    @click="uploadPicture">
                                    Update Picture
                                  </v-btn>
                                </div>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <v-row class="black--text" v-if="!loading.getdata && datalist.length <= 0">
              <v-col cols="12" md="12">
                <v-alert type="warning">
                  Data not available, please try refreshing the data with the button below!
                </v-alert>
                <div class="text-center">
                  <v-btn
                    fab
                    depressed
                    color="primary"
                    @click="getProfile">
                    <v-icon dark large>
                      mdi-refresh
                    </v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- dialog -->
    <v-dialog
      v-model="dmodal.profile"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.profile">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Update Profile {{ dmodaldata.profile.user_lastname }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('profile')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="10">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitUpdateProfile"
                    ref="formupdprofile"
                    v-model="formadd.company"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="8">
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              v-model="dmodaldata.profile.js_pref_special"
                              :items="listspecial"
                              :rules="[rules.required]"
                              label="Specialization">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              v-model="dmodaldata.profile.js_pref_location"
                              :items="listlocation"
                              :rules="[rules.required]"
                              label="Location">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.profile.js_pref_salary"
                              :rules="[rules.required]"
                              label="Expected salary *"
                              name="js_pref_salary"
                              type="number">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.profile.js_phone"
                              :rules="[rules.required]"
                              label="Phone *"
                              name="js_phone">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.profile.js_address"
                              :rules="[rules.required]"
                              label="Address *"
                              name="js_address">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <label>About me</label>
                            <vue-editor
                              v-model="dmodaldata.profile.js_desc"
                              placeholder="Description"
                              :rules="[rules.required]">
                            </vue-editor>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-autocomplete
                              v-model="dmodaldata.profile.js_sex"
                              :items="listgender"
                              :rules="[rules.required]"
                              label="Gender *"
                              name="js_sex">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-menu
                              v-model="datepick.birthdate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="dmodaldata.profile.js_birthdate"
                                  label="Birthday (yyyy-mm-dd) *"
                                  readonly
                                  v-on="on"
                                  :rules="[rules.required]">
                                </v-text-field>
                              </template>
                              <v-date-picker
                                ref="birthday"
                                :max="datepick.date"
                                name="js_birthdate"
                                v-model="dmodaldata.profile.js_birthdate"
                                @input="datepick.birthdate = false">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.profile.js_birthplace"
                              :rules="[rules.required]"
                              label="Birthplace *"
                              name="js_birthplace">
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.updcomp"
                          :disabled="loading.updcomp || !formadd.company"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Update profile
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog edit account -->
    <v-dialog
      v-model="dmodal.account"
      max-width="600px">
      <v-card v-if="dmodaldata.account">
        <v-card-title>
          <span class="headline">Update account data</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.account = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitUpdateAccount"
              ref="formupdateaccount"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="dmodaldata.account.user_firstname"
                        :rules="[rules.required]"
                        label="First name"
                        name="firstname"
                        required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="dmodaldata.account.user_lastname"
                        :rules="[rules.required]"
                        label="Last name"
                        name="lastname"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" class="text-center">
                      <alertsp :alertdata="alertupdate"></alertsp>
                      <v-btn
                        large
                        color="error"
                        class="mx-2 mt-5"
                        @click="closeDmodal('account')">
                        Cancel
                      </v-btn>
                      <v-btn
                        large
                        :loading="loading.updcomp"
                        :disabled="loading.updcomp || !formupdate.valid"
                        color="success"
                        class="mx-2 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { VueEditor } from 'vue2-editor';
import { priceFromat, getGdriveView } from '@/plugins/utils';

export default {
  name: 'ProfileMhs',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertpic: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      updcomp: false,
      avatar: false,
      resume: false,
      addedu: false,
      getedu: false,
      addexp: false,
      getexp: false,
    },
    tabdata: 'profile',
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    dataedu: [],
    dataexp: [],
    listgender: ['male', 'female', 'other'],
    listlocation: ['BADUNG', 'DENPASAR', 'GIANYAR', 'TABANAN'],
    listspecial: ['IT-Software', 'IT-Hardware', 'Hotel', 'Tourism', 'Public Relations', 'Banking', 'Accounting'],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    addedu: {
      edu_institute: '',
      edu_graduate: '',
      edu_degree: '',
      edu_field: '',
      edu_major: '',
      edu_gpa: '',
      edu_desc: '',
    },
    addexp: {
      exp_position: '',
      ext_company: '',
      exp_join: '',
      exp_end: '',
      exp_present: true,
      exp_special: '',
      exp_level: '',
      exp_desc: '',
    },
    formadd: {
      company: false,
      education: false,
      experience: false,
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
      files: [
        (value) => !value || value.size < 2000000 || 'Files less than 2 MB!',
      ],
    },
    tabdata: null,
    dmodal: {
      profile: false,
      account: false,
      addedu: false,
      editedu: false,
      addexp: false,
      editexp: false,
      delexp: false,
    },
    dmodaldata: {
      profile: null,
      account: null,
      editedu: null,
      editexp: null,
      delexp: null,
    },
    myCroppa: {},
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      birthdate: false,
      addedu: false,
      editedu: false,
      addexp: false,
      editexp: false,
      addexpend: false,
    },
    addresume: {
      file: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'useremail',
    ]),
  },
  mounted() {
    this.getProfile();
  },
  watch: {
    'datepick.birthdate'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
    'datepick.addedu'(val) {
      if (val) {
        setTimeout(() => (this.$refs.graduationdate.activePicker = 'YEAR'));
      }
    },
    'datepick.addexp'(val) {
      if (val) {
        setTimeout(() => (this.$refs.expjoin.activePicker = 'YEAR'));
      }
    },
    'datepick.addexpend'(val) {
      if (val) {
        setTimeout(() => (this.$refs.expjoinend.activePicker = 'YEAR'));
      }
    },
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getPdfView(url) {
      return getGdriveView(url);
    },
    uploadResume() {
      this.alertdata.show = false;
      if (this.$refs.formupladresume.validate()) {
        if (this.tokenscr) {
          this.loading.resume = true;
          const dataadd = this.addresume;
          const formData = new FormData();
          // file image
          formData.append('fileresume', dataadd.file);
          formData.append('oldfileresume', this.datalist[0].js_resume);
          // send data
          this.axios
            .post(
              this.api + '/api/user/updateresume',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.datalist[0].js_resume = resdata.data.name;
                  this.datalist[0].urlresume = this.api + '/upload/resume/' + resdata.data.name;
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Resume updated successfully';
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.resume = false;
            })
            .catch((error) => {
              this.loading.resume = false;
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    uploadPicture() {
      const $thisvue = this;
      this.myCroppa.generateBlob((blob) => {
        $thisvue.alertpic.show = false;
        if (blob) {
          $thisvue.loading.avatar = true;
          const formData = new FormData();
          // file image
          formData.append('filepic', blob, 'newpic.png');
          formData.append('oldpic', $thisvue.datalist[0].st_pic);
          $thisvue.axios
            .post(
              $thisvue.api + '/api/user/mhs-picture',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + $thisvue.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  $thisvue.datalist[0].urlpic = $thisvue.api + '/upload/avatar/' + resdata.data.name;
                  $thisvue.datalist[0].com_picture = resdata.data.name;
                  $thisvue.myCroppa.remove();
                } else {
                  $thisvue.alertpic.show = true;
                  $thisvue.alertpic.type = 'error';
                  $thisvue.alertpic.text = resdata.message;
                }
              } else {
                $thisvue.alertpic.show = true;
                $thisvue.alertpic.type = 'error';
                $thisvue.alertpic.text = 'Internal services error!';
              }
              $thisvue.loading.avatar = false;
            })
            .catch((error) => {
              console.log('Internal services error!');
              $thisvue.alertpic.show = true;
              $thisvue.alertpic.type = 'error';
              $thisvue.alertpic.text = 'Internal services error!';
              $thisvue.loading.avatar = false;
            });
          // console.log(blob);
        } else {
          $thisvue.alertpic.show = true;
          $thisvue.alertpic.type = 'error';
          $thisvue.alertpic.text = 'Please select the image!';
        }
      }, 'image/png', 0.8);
    },
    getProfile() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/user/profile',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.datalist = resdata.data;
                if (resdata.data[0].st_pic) {
                  this.datalist[0].urlpic = this.api + '/upload/avatar/' + resdata.data[0].st_pic;
                  // this.datalist[0].urlresume = this.api + '/upload/resume/' + resdata.data[0].js_resume;
                } else {
                  this.datalist[0].urlpic = '';
                }
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.addjeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddjeniskerja.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'pekerjaan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getProfile();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'profile') {
        this.dmodal.profile = false;
      } else if (type === 'account') {
        this.dmodal.account = false;
      } else if (type === 'addedu') {
        this.dmodal.addedu = false;
      } else if (type === 'editedu') {
        this.dmodal.editedu = false;
      } else if (type === 'addexp') {
        this.dmodal.addexp = false;
      } else if (type === 'editexp') {
        this.dmodal.editexp = false;
      } else {
        this.dmodal.profile = false;
      }
    },
    updateProfile(item) {
      this.dmodal.profile = true;
      this.dmodaldata.profile = JSON.parse(JSON.stringify(item));
    },
    submitUpdateProfile() {
      // console.log(this.dmodaldata.profile);
      this.alertupdate.show = false;
      if (this.$refs.formupdprofile.validate()) {
        if (this.tokenscr) {
          this.loading.updcomp = true;
          this.axios
            .put(
              this.api + '/api/user/js-profile',
              qs.stringify(
                this.dmodaldata.profile,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = this.dmodaldata.profile.user_lastname + ' has been changed successfully!';
                  this.getProfile();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.updcomp = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.updcomp = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    updateAccount(item) {
      this.dmodal.account = true;
      this.dmodaldata.account = JSON.parse(JSON.stringify(item));
      this.alertupdate.show = false;
    },
    submitUpdateAccount() {
      // console.log(this.dmodaldata.account);
      this.alertupdate.show = false;
      if (this.$refs.formupdateaccount.validate()) {
        if (this.tokenscr) {
          const datasend = {
            firstname: this.dmodaldata.account.user_firstname,
            lastname: this.dmodaldata.account.user_lastname,
          };
          this.loading.updcomp = true;
          this.axios
            .put(
              this.api + '/api/user/mhs-account',
              qs.stringify(
                datasend,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Your account data has been changed successfully!';
                  this.getProfile();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.updcomp = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.updcomp = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    updateExpend() {
      if (this.addexp.exp_present) {
        this.addexp.exp_end = '';
      } else {
        this.addexp.exp_end = this.addexp.exp_join;
      }
    },
    changeTab() {
      if (this.tabdata === 'edu') {
        this.getEducation();
      } else if (this.tabdata === 'exp') {
        this.getExperience();
      }
    },
    addEducation() {
      this.dmodal.addedu = true;
      this.alertupdate.show = false;
    },
    editEducation(item) {
      this.dmodal.editedu = true;
      this.dmodaldata.editedu = JSON.parse(JSON.stringify(item));
      this.alertupdate.show = false;
    },
    getEducation() {
      if (this.tokenscr) {
        this.loading.getedu = true;
        this.axios
          .get(
            this.api + '/api/education/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.dataedu = resdata.data;
                // console.log(this.dataedu);
              }
            }
            this.loading.getedu = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getedu = false;
          });
      }
    },
    submitAddEducation() {
      // console.log(this.addedu);
      this.alertupdate.show = false;
      if (this.$refs.formaddeducation.validate()) {
        if (this.tokenscr) {
          this.loading.addedu = true;
          this.axios
            .post(
              this.api + '/api/education/',
              qs.stringify(
                this.addedu,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.$refs.formaddeducation.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Your education qualification in "' + resdata.data + '" has been added!';
                  this.getEducation();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addedu = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.addedu = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    submitEditEducation() {
      // console.log(this.dmodaldata.editedu);
      this.alertupdate.show = false;
      if (this.$refs.formediteducation.validate()) {
        if (this.tokenscr) {
          this.loading.addedu = true;
          this.axios
            .put(
              this.api + '/api/education/',
              qs.stringify(
                this.dmodaldata.editedu,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Your education qualifications have been changed successfully!';
                  this.getEducation();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addedu = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.addedu = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    addExp() {
      this.dmodal.addexp = true;
      this.alertupdate.show = false;
    },
    deleteExperience(item) {
      this.dmodal.delexp = true;
      this.dmodaldata.delexp = JSON.parse(JSON.stringify(item));
      this.alertupdate.show = false;
    },
    editExperience(item) {
      this.dmodal.editexp = true;
      this.dmodaldata.editexp = JSON.parse(JSON.stringify(item));
      this.dmodaldata.editexp.exp_present = JSON.parse(this.dmodaldata.editexp.exp_present);
      this.alertupdate.show = false;
    },
    getExperience() {
      // console.log('get list');
      if (this.tokenscr) {
        this.loading.getexp = true;
        this.axios
          .get(
            this.api + '/api/experience/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.dataexp = resdata.data;
                // console.log(this.dataexp);
              }
            }
            this.loading.getexp = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getexp = false;
          });
      }
    },
    submitAddExperience() {
      // console.log(this.addexp);
      this.alertupdate.show = false;
      if (this.$refs.formaddexperience.validate()) {
        if (this.tokenscr) {
          this.loading.addexp = true;
          this.axios
            .post(
              this.api + '/api/experience/',
              qs.stringify(
                this.addexp,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.$refs.formaddexperience.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Your experience "' + resdata.data + '" has been added!';
                  this.getExperience();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addexp = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.addexp = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    submitEditExperience() {
      this.alertupdate.show = false;
      if (this.$refs.formeditexperience.validate()) {
        if (this.tokenscr) {
          this.loading.addexp = true;
          this.axios
            .put(
              this.api + '/api/experience/',
              qs.stringify(
                this.dmodaldata.editexp,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Your experience has been changed successfully!';
                  this.getExperience();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addexp = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.addexp = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    deleteExpconfirm(item) {
      if (this.tokenscr) {
        this.alertupdate.show = false;
        this.loading.getexp = true;
        this.axios
          .delete(
            this.api + '/api/experience/' + item,
            {
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dmodal.delexp = false;
                this.dmodaldata.delexp = null;
                this.getExperience();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.getexp = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.getexp = false;
          });
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
